import { useMutation } from "react-query";

import { useNotify } from "~/shared/hooks/useNotify";

import { useIvideon } from "./useIvideon";

export const useGetDealerOfflineReport = (closeModal: () => void) => {
  const { getDealerOfflineReport } = useIvideon();
  const { notifyReport } = useNotify();
  const { data, isLoading, isError, mutate } = useMutation({
    mutationFn: (sort: string) => getDealerOfflineReport(sort),

    onSuccess: (response) => {
      const hash = response?.data?.fileHash;
      if (hash) {
        notifyReport(hash);

        closeModal();
      }
    },
  });

  return {
    data: data?.data,
    isLoading: isLoading,
    isError: isError,
    getDealerOfflineDataReport: mutate,
  };
};
